import { SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import ListIcon from '@material-ui/icons/List'
import LocalHospitalIcon from '@material-ui/icons/LocalHospital'
import PersonIcon from '@material-ui/icons/Person'

export interface MenuOptionProps {
  title: string
  icon: OverridableComponent<SvgIconTypeMap<unknown, 'svg'>>
  path: string
}

export const MenuOptions: MenuOptionProps[] = [
  {
    icon: PersonIcon,
    path: '/configuracao/conta',
    title: 'Conta'
  },
  // {
  //   icon: PaymentIcon,
  //   path: '/configuracao/planos',
  //   title: 'Plano de Assinatura'
  // },
  {
    icon: LocalHospitalIcon,
    path: '/configuracao/procedimentos',
    title: 'Procedimentos'
  },
  {
    icon: ListIcon,
    path: '/configuracao/pedidos',
    title: 'Pedidos'
  }
]
